import { render, staticRenderFns } from "./admissions.html?vue&type=template&id=42709940&scoped=true&external"
import script from "./admissions.js?vue&type=script&lang=js&external"
export * from "./admissions.js?vue&type=script&lang=js&external"
import style0 from "./admissions.scss?vue&type=style&index=0&id=42709940&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42709940",
  null
  
)

export default component.exports